import { render, staticRenderFns } from "./CardClassEvent.vue?vue&type=template&id=c049e22c&scoped=true&"
import script from "./CardClassEvent.vue?vue&type=script&lang=js&"
export * from "./CardClassEvent.vue?vue&type=script&lang=js&"
import style0 from "./CardClassEvent.vue?vue&type=style&index=0&id=c049e22c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c049e22c",
  null
  
)

export default component.exports